import { configureStore } from "shared/store";
import { isManagerApp } from "shared/utils/auth";

const createStore = () => (isManagerApp() ? configureStore() : null);

export default createStore;
